// extracted by mini-css-extract-plugin
export default {"event_deadline":"styles_event_deadline__VRl02"};